module.exports = __webpack_public_path__ + "static/DLProd-Sample-cfcffa77c61fe8e22ce13ee8a3839980.pdf";